<template>
  <div>
    <div class="bordeador">
      <label class="mt-2"><slot name="label"></slot></label>
      <div class="btn-group-horizontal pb-2">
        <template v-if="!disabled">
          <input
            :checked="Todos"
            @input="clickTodos"
            :disabled="disabled"
            type="checkbox"
            class="btn-check"
            name="checkweekday"
            id="checkweekdayTodos"
            autocomplete="off"
          />
          <label
            class="btn"
            for="checkweekdayTodos"
            :class="[Todos ? 'btn-success' : 'btn-outline-danger']"
            >Todos</label
          >
        </template>

        <input
          :value="1"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday1"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday1"
          :class="[diaElegido(1) ? 'btn-success' : 'btn-outline-danger']"
          >Lunes</label
        >

        <input
          :value="2"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday2"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday2"
          :class="[diaElegido(2) ? 'btn-success' : 'btn-outline-danger']"
          >Martes</label
        >

        <input
          :value="3"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday3"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday3"
          :class="[diaElegido(3) ? 'btn-success' : 'btn-outline-danger']"
          >Miércoles</label
        >

        <input
          :value="4"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday4"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday4"
          :class="[diaElegido(4) ? 'btn-success' : 'btn-outline-danger']"
          >Jueves</label
        >

        <input
          :value="5"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday5"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday5"
          :class="[diaElegido(5) ? 'btn-success' : 'btn-outline-danger']"
          >Viernes</label
        >

        <input
          :value="6"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday6"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday6"
          :class="[diaElegido(6) ? 'btn-success' : 'btn-outline-danger']"
          >Sábado</label
        >

        <input
          :value="7"
          v-model="days"
          @input="handleInput"
          :disabled="disabled"
          type="checkbox"
          class="btn-check"
          name="checkweekday"
          id="checkweekday7"
          autocomplete="off"
        />
        <label
          class="btn"
          for="checkweekday7"
          :class="[diaElegido(7) ? 'btn-success' : 'btn-outline-danger']"
          >Domingo</label
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Util } from "../../util";
export default {
  props: {
    disabled: Boolean,
    // "value" es usado por los v-model
    value: Array,
  },
  data() {
    return {
      days: this.value,
    };
  },
  computed: {
    Todos() {
      return this.days && this.days.length == 7;
    },
  },
  watch: {
    // Se usa un array interno para no mutar el externo directamente
    // Cuando el externo cambia, reflejar los cambios en el interno
    value(newValue) {
      this.days = newValue;
    },
  },
  methods: {
    diaElegido(numeroDia) {
      return this.days && this.days.includes(numeroDia);
    },
    // Cuando un checkbox es elegido, avisar afuera el cambio
    // Nuestro array interno será luego cambiado en el watch
    handleInput(e) {
      // Trabajar con una copia profunda para no tocar el array original antes de emitir el evento
      const array = this.days ? Util.copiaProfunda(this.days) : [];

      // Numero del día, del 1 al 7
      const day = parseInt(e.target.value);

      const index = array.findIndex((d) => d == day);
      // Si el dia ya estaba elegido, eliminar
      if (index >= 0) {
        Util.eliminarEn(array, index);
      }
      // El día no estaba elegido, agregar
      else {
        array.push(day);
      }

      // Aprovechar para ordenar el array
      array.sort();

      // El evento "input" es usado para los v-model
      this.$emit("input", array);
    },
    clickTodos() {
      let array = [];

      // No estaban seleccionados todos, seleccionarlos
      if (!this.days || this.days.length != 7) {
        array = [1, 2, 3, 4, 5, 6, 7];
      }
      // Caso contrario, queda array vacía, sin días elegidos

      // El evento "input" es usado para los v-model
      this.$emit("input", array);
    },
  },
};
</script>
<style scoped>
.bordeador {
  outline: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>